"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onEscapeAction = void 0;
const urlHandler_1 = require("../../../../modules/urlHandler");
const onEscapeAction = ({ initValue, inputValue, setAutoValue, setFocus, setInputValue, }) => {
    const searchQuery = (0, urlHandler_1.getQueryParams)();
    if (initValue && inputValue && initValue !== inputValue) {
        setAutoValue({ rest: null, keyword: null });
    }
    setFocus(false);
    setInputValue(searchQuery.query ? searchQuery.query : "");
};
exports.onEscapeAction = onEscapeAction;
